import React from "react";

/**
 * StepIndicator Component
 *
 * Displays the current step number out of total steps (e.g., "Step 3 of 5").
 *
 * @param {number} currentStep - The current step number
 * @param {number} totalSteps - The total number of steps
 */
const StepIndicator = ({ currentStep, totalSteps }) => {
  return (
    <div
      style={{
        fontSize: "13px",
        fontWeight: "500",
        color: "#737373",
        marginBottom: "24px",
        textAlign: "center",
        letterSpacing: "0.05em",
        textTransform: "uppercase",
      }}
    >
      Step {currentStep} of {totalSteps}
    </div>
  );
};

export default StepIndicator;
